<template>
    <div>
          <app-layout>
              <template v-slot:header>
                  <Header :title="$t('my_observer')"
                          :isColumns="true"
                          :isFilter="false"
                       >
                      <template v-slot:columns>
                          <div class="mb-1" v-for="(column,key) in datatable.columns">
                              <b-form-checkbox
                                  :id="'checkbox-'+key"
                                  :name="'checkbox-'+key"
                                  :value="false"
                                  :unchecked-value="true"
                                  v-model="column.hidden"
                                  v-if="column.field!='buttons'"
                              >
                                  {{ column.label }}
                              </b-form-checkbox>
                          </div>
                      </template>
                  </Header>
              </template>
              <template v-slot:header-mobile>
                  <HeaderMobile :title="$t('classroom')"
                                :isColumns="true"
                            >
                      <template v-slot:columns>
                          <div class="mb-1" v-for="(column,key) in datatable.columns">
                              <b-form-checkbox
                                  :id="'checkbox-'+key"
                                  :name="'checkbox-'+key"
                                  :value="false"
                                  :unchecked-value="true"
                                  v-model="column.hidden"
                                  v-if="column.field!='buttons'"
                              >
                                  {{ column.label }}
                              </b-form-checkbox>
                          </div>
                      </template>
                  </HeaderMobile>
              </template>
              <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear" :exportExcel="true" @exportExcel="downloadExcel">
                  <b-row>
                      <b-col md="6" lg="4">
                          <b-form-group :label="$t('exam_date')">
                              <select-date v-model="datatable.queryParams.filter.date"/>
                          </b-form-group>
                      </b-col>
                      <b-col md="6" lg="4">
                          <b-form-group :label="$t('start_time')">
                              <b-form-input type="time" v-model="datatable.queryParams.filter.start_time">
                              </b-form-input>
                          </b-form-group>
                      </b-col>
                      <b-col md="6" lg="4">
                          <b-form-group :label="$t('end_time')">
                              <b-form-input type="time" v-model="datatable.queryParams.filter.end_time">
                              </b-form-input>
                          </b-form-group>
                      </b-col>
                      <b-col md="6" lg="4">
                              <b-form-group :label="$t('exam_type')">
                                  <parameter-selectbox
                                      v-model="datatable.queryParams.filter.exam_type"
                                      code="exam_schedules_types"/>
                              </b-form-group>
                      </b-col>
                  </b-row>
              </datatable-filter>

              <datatable :isLoading.sync="datatable.isLoading"
                         :columns="datatable.columns"
                         :rows="datatable.rows"
                         :total="datatable.total"
                         :queryParams="datatable.queryParams"
                         @on-page-change="onPageChange"
                         @on-sort-change="onSortChange"
                         @on-per-page-change="onPerPageChange"
                         v-show="datatable.showTable"
              >
              </datatable>
          </app-layout>
    </div>
</template>
<script>
//components
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import qs from "qs";
//services
import TeacherClassroomFilterService from "@/services/TeacherClassroomFilterService";
import ClassroomService from "@/services/ClassroomService";




export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,

    },
    metaInfo() {
        return {
            title: this.$t('my_observer')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [

                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('course_code'),
                        field: 'course_code',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('course_name'),
                        field: this.getLocaleField('course_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('classroom'),
                        field: 'classroom',
                        hidden: false,
                    },


                    {
                        label: this.toUpperCase('instructor'),
                        field: 'instructor',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('start_time'),
                        field: 'start_time',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('end_time'),
                        field: 'end_time',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('date'),
                        field: 'date',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('exam_type'),
                        field: this.getLocaleField('type'),
                        hidden: false,
                    },

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: -1
                }
            },
        }
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {

            }
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },

        downloadExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            TeacherClassroomFilterService.downloadExcel(config)
                .then(res => this._downloadFile(res, this.$t('my_observer') + '.xlsx'))
                .catch(err => this.showErrors(err))
        },

        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            return TeacherClassroomFilterService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
    },
  /*  created() {
       this.getRows()
    }*/
}

</script>
